/**
 * ProductionUtils
 *
 * From: 1.0.0
 * @packageDocumentation
 */

const methods: readonly (keyof Omit<Console, 'Console'>)[] = [
  'assert',
  'clear',
  'count',
  'debug',
  'dir',
  'dirxml',
  // 'error',
  // 'exception',
  'group',
  'groupCollapsed',
  'groupEnd',
  // 'info',
  'log',
  'profile',
  'profileEnd',
  'table',
  'time',
  'timeEnd',
  'timeStamp',
  'trace',
  // 'warn',
] as const;

export const suppressLog = () =>
  methods.forEach((method) => {
    console[method] = () => {
      return;
    };
  });
